/** The five-gem row from the hero wordmark and footer signature. Decorative only. */
export const Gems = ({ className = "", size = "h-2 w-6" }) => (
  <div aria-hidden="true" className={`flex items-center gap-2 ${className}`}>
    <span className={`${size} rounded-full bg-tangerine`} />
    <span className={`${size} rounded-full bg-cobalt`} />
    <span className={`${size} rounded-full bg-grass`} />
    <span className={`${size} rounded-full bg-blossom`} />
    <span className={`${size} rounded-full bg-yellow`} />
  </div>
);
